import { AppDispatch } from 'client/store'
import { SET_IS_PREVIEW_MODE } from 'src/editor/store/website-pages/website-pages-action-types'
import { SetIsPreviewMode } from 'src/editor/store/website-pages/website-pages-reducer'
import { WebsitePageDataInterface } from 'src/shared/types/website-settings-types'
import { setWebsiteSettings } from '../website-settings/website-settings-actions'

export const fetchWebsitePageDataSuccess =
  (data: WebsitePageDataInterface) => async (dispatch: AppDispatch) => {
    dispatch(setWebsiteSettings(data))
  }

export const setIsPreviewMode = (previewMode: boolean): SetIsPreviewMode => ({
  type: SET_IS_PREVIEW_MODE,
  payload: previewMode,
})

export type WebsitePagesActions = SetIsPreviewMode
